export const COMMIT_SIZE_INITIAL = 2;
export const COMMIT_SIZE_INCREMENT = 5;
export const BRANCH_SIZE_INITIAL = 5;
export const BRANCH_SIZE_INCREMENT = 10;
